/// <amd-module name="Test/FailedTestsMetricView/Actions/FailedTestsMetricActions" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { Action } from "VSS/Reflux/Action";

export class FailedTestsMetricActions {
    public updateConfigurationValuesAction: Action<CommonTypes.IReportConfiguration> = new Action<CommonTypes.IReportConfiguration>();
    public updateFailedTestsMetricAction: Action<CommonTypes.IFailedCardMetricData> = new Action<CommonTypes.IFailedCardMetricData>();
    public updateFlakyTestsMetricAction: Action<number> = new Action<number>();
    public onError = new Action<Error>();
}
